<template>
  <div class="addevent container-fluid">
    <div class="container-fluid">
      <div class="row mx-0" id="dashboardCardDiv">
        <div class="col-md-12 px-0">
          <div class="card card-transparent-background mx-1">
            <div class="card-header row p-0">
              <div class="col-12 pl-0">
                <h4 class="card-title  card-title-doom-yoga">Music Library</h4>
              </div>
            </div>
          </div>
          <div class="createeventCard">
            <b-tabs class="evnetTypesTabs">
              <b-tab
                title="Spotify"
                active
                title-link-class="btn btn-tab btn-doomyoga-secondary" 
              >
                <SpotifyPlaylists client_name="DY" class="mt-3"
              />
            </b-tab>
              <b-tab
                title="MP3"
                title-link-class="btn btn-tab btn-doomyoga-secondary"
                ><MP3Playlists
              /></b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpotifyPlaylists from "@/components/music_library/SpotifyPlaylists.vue";

import MP3Playlists from "./MP3Playlists.vue";

export default {
  name: "MusicLibrary",
  components: {  MP3Playlists , SpotifyPlaylists},
  data() {
    return {};
  },
  mounted(){
    console.log(process)
    console.log(process.env)
    console.log(process.env.TEST)
    console.log(process.env.NODE_ENV)
  }
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/music_library/Index.vue